'use strict';

module.exports = comment;

/* Stringify a comment `node`. */
function comment(ctx, node) {
  return '<!--' + node.value + '-->';
}



//////////////////
// WEBPACK FOOTER
// ./~/hast-util-to-html/lib/comment.js
// module id = 721
// module chunks = 168707334958949